export class WorkrequestDetailsBase {
  totalOrderAmount: number;
  descriptionOfWork: string;
  comment: string;

  constructor() {
    this.totalOrderAmount = 0;
    this.descriptionOfWork = '';
    this.comment = '';
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/data-objects/workrequest-details-base.ts